import { render, staticRenderFns } from "./ChangePassModal.vue?vue&type=template&id=b975234c&scoped=true"
import script from "./ChangePassModal.vue?vue&type=script&lang=js"
export * from "./ChangePassModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b975234c",
  null
  
)

export default component.exports